//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { useEffect, useState } from 'react';

import uuid from '@utils/uuid';

/**
 * Creates and stores a unique id with a given prefix.
 *
 * ex: useUniqueId('some-id') --> 'some-id-123e4567-e89b-12d3-a456-426614174000'
 */
export const useUniqueId = (idPrefix: string) => {
  const [uniqueId, setUniqueId] = useState('');
  useEffect(() => {
    setUniqueId(`${idPrefix}-${uuid()}`);
  }, [idPrefix]);

  return uniqueId;
};
